var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngle = function SvgAngle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 5,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.039,
    d: "M7.125.457a.29.29 0 0 1 .27.18.31.31 0 0 1-.061.322L4.209 4.084a.3.3 0 0 1-.418 0L.666.959A.31.31 0 0 1 .604.636a.29.29 0 0 1 .27-.179h6.251Z"
  })));
};
export default SvgAngle;